


















import { Component, Vue } from 'vue-property-decorator';
import CommonForm from './common/CommonForm.vue';

@Component({
  components: {
    CommonForm
  }
})
export default class ChangeEmail extends Vue {
  errorMessage: string | null = null;

  beforeMount() {
    this.errorMessage = this.getQueryParam('error');
  }

  get emailSuccessfullyChanged(): boolean {
    return this.getQueryParam('success') === 'true';
  }

  get showErrorMessage(): boolean {
    return !!this.errorMessage;
  }

  private getQueryParam(paramName: string) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(paramName);
  }
}
